<template>
  <div class="block" v-if="isSidebarActive">

    <!-- Capture -->
    <div class="block-header mt20 mb20">
      <!-- Capture title -->
      <h1 class="block-header-title no-underline" v-if="isCategoriesLoaded"> {{ $t('Departments') }} </h1>
      <!---->
      <!-- Preloader -->
      <div v-else>
        <article-preloader />
      </div>
      <!---->
    </div>
    <!---->
    <!-- List -->
    <div class="block-list" v-if="isCategoriesLoaded">
      <side-category-link v-if="discountedProductsLinkAllowed" :item="discountedProductsLink" key="discount-products" />
      <side-category-link v-for="item in category" :item="item" :key="item.entity_id" />
    </div>
    <!---->
    <!-- Preloader -->
    <div class="block-list" v-else>
      <nav-panel-preloader v-for="item in pleloaderItems" :key="item" />
    </div>
    <!---->
  </div>
</template>

<script>
import SideCategoryLink from 'theme/components/core/blocks/Shop/Sidebar/SideCategoryLink'
import NavPanelPreloader from 'theme/components/theme/blocks/Home/Preloaders/NavPanelPreloader'
import ArticlePreloader from 'theme/components/theme/blocks/Home/Preloaders/ArticlePreloader'
import { mapGetters } from 'vuex'

export default {
  components: {
    SideCategoryLink,
    NavPanelPreloader,
    ArticlePreloader
  },
  data () {
    return {
      // Count of preloader items
      pleloaderItems: 14,
      category: [],
      isSidebarActive: true,
      discountedProductsLink: {
        name: 'Товари зі знижкою',
        url_path: 'discounted-products',
        url_key: 'discounted-products',
        slug: 'discounted-products',
        children_count: 0,
        children_data: [],
        product_count: 0
      }
    }
  },
  props: {
    // Loading status of static categories
    isCategoriesLoaded: {
      type: Boolean,
      default: () => false
    },

    // Array of categories
    categories: {
      required: true
    }
  },
  mounted () {
    this.createUnderRootCategory()
  },
  watch: {
    '$route.params.slug': {
      handler: function () {
        this.createUnderRootCategory()
      }
    },
    categories () {
      this.createUnderRootCategory()
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner'
    }),
    getUnderRootCategory () {
      let underRootCategory = this.$route.path.split('/')[3]
      return this.categories && this.categories.length ? this.categories.filter(el => el.level === 2 && el.url_path.indexOf(underRootCategory) !== -1)[0] : []
    },
    discountedProductsLinkAllowed () {
      return this.$route.path.split('/').length === 3
    }
  },
  methods: {
    createUnderRootCategory () {
      if (this.category.length) this.category.splice(0, this.category.length)
      if (this.getUnderRootCategory && this.getUnderRootCategory.hasOwnProperty('children_data') && this.getUnderRootCategory.children_data.length) {
        this.isSidebarActive = true
        if (!this.$route.params.childSku) {
          this.getUnderRootCategory.children_data.map(el => this.category.push(el))
        } else {
          this.categories.map(el => this.category.push(el))
        }
      } else {
        this.isSidebarActive = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  &-header {
    &-title {
      color: #111;
      font-size: 18px;
      font-weight: 600;
    }
  }

  &-list {
    display: flex;
    flex-direction: column;

    padding: 10px 0;
    border-top: solid 1px #f5f5f5;
    border-bottom: solid 1px #f5f5f5;
  }
}
</style>
